enum MutationType {
    Created = 1,
    Updated = 2,
    Deleted = 3,
    Patched = 4,
}

export default MutationType;
